import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import Settings from './Settings'
import templates from './Templates'
import script from './Script'
import notifications from './Notifications'

export default combineReducers({
  routing: routerReducer,
  settings: Settings,
  templates,
  script,
  notifications
})



// WEBPACK FOOTER //
// ./reducers/index.js